module.exports = __webpack_public_path__ + "lp/img/vote_verybad.4a99d5a9.svg";